
import React, { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import { ThemeContext } from '../context/ThemeContext';
import { content } from '../content';

const Contact = () => {
  const { language } = useContext(LanguageContext);
  const { theme } = useContext(ThemeContext);
  const contactContent = content[language].contact;

  return (
    <section id="contact" className={`py-12 md:py-16 px-4 ${theme === 'dark' ? 'bg-gray-900' : 'bg-white'}`}>
      <div className="container mx-auto text-center">
        <h2 className={`text-3xl md:text-4xl font-extrabold mb-10 md:mb-12 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>{contactContent.title}</h2>
        
        <div className={`max-w-4xl mx-auto flex flex-col md:flex-row justify-around items-center text-base md:text-lg ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
          
          {/* Location Info */}
          <div className="mb-8 md:mb-0">
            <h3 className={`text-xl md:text-2xl font-bold mb-3 ${theme === 'dark' ? 'text-white' : 'text-gray-800'}`}>{contactContent.location}</h3>
            <p>{contactContent.street}</p>
            <p>{contactContent.city}</p>
            <p>{contactContent.country}</p>
          </div>

          {/* Divider for mobile */}
          <div className='w-3/4 md:hidden h-px bg-gray-300 my-6'></div>

          {/* Get in Touch Info */}
          <div>
            <h3 className={`text-xl md:text-2xl font-bold mb-3 ${theme === 'dark' ? 'text-white' : 'text-gray-800'}`}>{contactContent.getInTouch}</h3>
            <p>
              <a href={`mailto:${contactContent.email}`} className="hover:text-blue-500 transition-colors duration-300">
                {contactContent.email}
              </a>
            </p>
            <p>{contactContent.phone}</p>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default Contact;
